// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"d2784edc","73":"84494921","126":"ca4f7b63","191":"e41aaf8e","215":"422b6306","453":"3e206d3e","785":"155244b4","807":"8bbd0312","874":"7b699242"}[chunkId] + ".chunk.js";
};